"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _PricingSelectors = require("pricing-pages-unified-ui/selectors/PricingSelectors");

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var ExampleSubtext = function ExampleSubtext(_ref) {
  var currencyCode = _ref.currencyCode,
      priceTiers = _ref.priceTiers,
      handleClickLink = _ref.handleClickLink,
      merchandiseId = _ref.merchandiseId,
      termId = _ref.termId;
  var exampleFirstValue = priceTiers[1].value;
  var exampleSecondValue = priceTiers[2].value;
  var totalPrice = (0, _reactRedux.useSelector)(function (state) {
    return (0, _PricingSelectors.calculatedPriceSelector)(state, {
      merchandiseId: merchandiseId,
      termId: termId,
      itemConfigurations: [{
        merchandiseId: merchandiseId,
        quantity: 4000
      }]
    });
  }).monthly.calculatedPrice;
  var HREF = (0, _urls.getProductsAndServicesCatalogUrl)();
  var isBuyingLegacyMarketingStarter250Contacts = merchandiseId === _MerchandiseIds.PRODUCT_MARKETING_STARTER_CONTACTS;
  return _react.default.createElement("div", {
    className: "text-left"
  }, _react.default.createElement("p", null, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "contactConfirmation.contactTierPricingModal.contactsSubtext1_jsx",
    elements: {
      UILink: _UILink.default
    },
    options: {
      onClick: function onClick() {
        for (var _len = arguments.length, partialArgs = new Array(_len), _key = 0; _key < _len; _key++) {
          partialArgs[_key] = arguments[_key];
        }

        return handleClickLink.apply(void 0, [HREF, 'marketing-stater-subtext1'].concat(partialArgs));
      },
      link: HREF
    }
  }))), _react.default.createElement("p", null, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "contactConfirmation.contactTierPricingModal.contactsSubtext2_jsx",
    elements: {
      FormattedNumber: _FormattedNumber.default
    }
  }))), // Since this copy is written specifically for new Marketing Starter Contacts,
  // we don't show this for legacy Marketing Starter Contacts
  !isBuyingLegacyMarketingStarter250Contacts && _react.default.createElement("p", {
    className: "p-left-8"
  }, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "contactConfirmation.contactTierPricingModal.contactsSubtext3_jsx",
    elements: {
      FormattedCurrency: _FormattedCurrency.default,
      FormattedNumber: _FormattedNumber.default
    },
    options: {
      firstValue: exampleFirstValue,
      secondValue: exampleSecondValue,
      thirdValue: totalPrice,
      currencyCode: currencyCode
    }
  }))), _react.default.createElement("p", {
    className: "m-bottom-0"
  }, _react.default.createElement(_Small.default, {
    use: "help"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "contactConfirmation.contactTierPricingModal.contactsSubtext4_jsx",
    elements: {
      UILink: _UILink.default
    },
    options: {
      onClick: function onClick() {
        for (var _len2 = arguments.length, partialArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          partialArgs[_key2] = arguments[_key2];
        }

        return handleClickLink.apply(void 0, [HREF, 'marketing-starter-subtext4'].concat(partialArgs));
      },
      link: HREF
    }
  }))));
};

var _default = ExampleSubtext;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/contacts-price-breakdown/ExampleSubtext.js
// module id = 681
// module chunks = 5 6